var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#052CC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9684 148C85.1094 148 83.3419 147.111 82.2338 145.581L59.0921 113.497H44V101.816H62.0775C63.9549 101.816 65.7132 102.713 66.8121 104.234L85.723 130.446L114.579 64.4998C115.513 62.3743 117.61 61 119.927 61H156V72.6812H123.746L92.3166 144.5C91.4741 146.424 89.67 147.743 87.582 147.963C87.3897 147.991 87.1791 148 86.9684 148Z",
    fill: "#00C389"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadixIcon);
export default __webpack_public_path__ + "static/media/radix-icon.703e21fb8504912b4521223457d238b3.svg";
export { ForwardRef as ReactComponent };